
import { motion } from 'framer-motion';

const CommunityHeader = () => {
  return (
    <div className="bg-omoduduwa-indigo text-white py-12">
      <div className="container-custom">
        <motion.h1 
          className="text-3xl md:text-4xl font-bold mb-2 text-white"
          style={{ textShadow: 'none' }}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Ọmọ Odùduwà Community
        </motion.h1>
        <motion.p 
          className="text-lg text-gray-200 max-w-2xl"
          style={{ textShadow: 'none' }}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Connect with fellow members, access resources, join the singles forum, and stay updated with local announcements
        </motion.p>
      </div>
    </div>
  );
};

export default CommunityHeader;
